import HCLDX from "@system/config/hcldx";
import System from "src/helper/system";
import Helper from "src/support/Helper";
const c = System.getParams();

class Admin {
  //USER
  static USER_LIST = Helper.getAdminConsoleUrl() + '/api/admin/users';
  static BOM_LIST = Helper.getAdminConsoleUrl() + '/api/admin/bomDataViewer';
  static DELETE_USERS = Helper.getAdminConsoleUrl() + `/api/admin/delete`;
  static EXPORT_USER_LIST = Helper.getAdminConsoleUrl() + `/api/admin/userExport`;
  static EMAIL_USER_LIST = Helper.getAdminConsoleUrl() + `/api/admin/emailUsers`;
  static ADD_USER = Helper.getAdminConsoleUrl() + `/api/admin/adduser`;
  static GET_USER_DETAIL = Helper.getAdminConsoleUrl() + `/api/admin/details`;
  static GET_USER_ACCT_LIST = Helper.getAdminConsoleUrl() + `/api/admin/accounts`;
  static GET_USER_SEARCH_ACCT_LIST = Helper.getAdminConsoleUrl() + `/api/admin/getallaccounts`;
  static UPDATE_USER_SPONSORSHIP = Helper.getAdminConsoleUrl() + `/api/admin/addRolestoAccounts`;
  static UPDATE_USER_UNSPONSOR_ACCT = Helper.getAdminConsoleUrl() + `/api/admin/unsponsoredaccounts`;
  static UPDATE_USER_UNSPONSOR_ACCT_BY_USER = Helper.getAdminConsoleUrl() + `/api/admin/unsponsoredaccountsbyUsers`;
  static SEARCH_SPONSOR_ACCOUNTS = Helper.getAdminConsoleUrl() + `/api/admin/searchSponsorAccounts`;
  static CHECK_USER_EMAIL = Helper.getAdminConsoleUrl() + `/api/admin/internalUserDetails`;
  // static EXPORT_ACCOUNT_LIST = Helper.getAdminConsoleUrl() + `/api/auth/validate`;
  static UPDATE_USER_DETAIL = Helper.getAdminConsoleUrl() + `/api/admin/edituser`;
  static UPDATE_USER_ACTIVE_STATUS = Helper.getAdminConsoleUrl() + `/api/admin/setUserStatus`;
  // Account
  static ACCOUNT_LIST = Helper.getAdminConsoleUrl() + '/api/admin/listofaccount';
  static ACCOUNT_DETAIL = Helper.getAdminConsoleUrl() + '/api/admin/users';
  static ACCOUNT_USER_LIST = Helper.getAdminConsoleUrl() + '/api/admin/users';
  static EMAIL_ACCOUNT_LIST = Helper.getAdminConsoleUrl() + '/api/admin/exportaccountsandsendmail';
  static EMAIL_ACCOUNT_USER_LIST = Helper.getAdminConsoleUrl() + '/api/admin/sendMailForAccountUserList';
  static ACCOUNT_EXPORT = Helper.getAdminConsoleUrl() + '/api/admin/exportaccountstoexcel';
  static EXPORT_ACCOUNT_USER_LIST = Helper.getAdminConsoleUrl() + '/api/admin/exportAccountUserList';

  static GET_ACCOUNT_DETAIL = Helper.getAdminConsoleUrl() + `/api/admin/AccountDetail`;
  static GET_ACCOUNT_USER_LIST = Helper.getAdminConsoleUrl() + `/api/admin/GetAccountSpecificUserAccounts`;
  // Reports
  static REPORTS_LIST = Helper.getAdminConsoleUrl() + '/api/admin/getlistofUserandAccountReport';
  static EXPORT_REPORT_LIST = Helper.getAdminConsoleUrl() + '/api/admin/exportAccountAndUsersReport';

  static EMAIL_REPORT_LIST = Helper.getAdminConsoleUrl() + '/api/admin/emailAccountAndUsersReport';
  //Admin
  static GET_ROLE_LIST = Helper.getAdminConsoleUrl() + `/api/admin/roles`;
  static GET_ORG_LIST = Helper.getAdminConsoleUrl() + `/api/admin/salesorglist`;
  static EDIT_USER_ROLES = Helper.getAdminConsoleUrl() + `/api/admin/editUserRoles`;

  static getAdminUserManagementURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/admin";
  }

  static getAdminUserDetailURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/admin/user/detail";
  }

  static getAdminAccountDetailURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/admin/account/detail";
  }

  static getAdminBOMManagementURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/sfdc-bom-management";
  }

  static getAdminBOMDetailURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/sfdc-bom-detail";
  }

  static getRegistrationURL() {
    return HCLDX.baseURL() + "/resources/my-avnet/registration";
  }

  static getRegisterURL() {
    return HCLDX.baseURL() + "/authenticate/register";
  }
}

export default Admin;
